import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PageModal from '../common/PageModal'
import SimpleButton from '../common/SimpleButton'
import { toast } from '../common/Toast'
import { postSparePartsRequestReview } from '../../utils/requests/spareparts'

const RequestReviewModal = ({ sparePart, onClose }) => {
  const { t } = useTranslation()
  const [comments, setComments] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const isSubmitDisabled = isSubmitting || !comments.trim()

  const handleSubmit = async () => {
    setIsSubmitting(true)
    try {
      await postSparePartsRequestReview({
        partNumber: sparePart.item_id,
        comments: comments.trim(),
      })
      toast.success(t('spareparts.request-submitted-successfully'))
      onClose()
    } catch (error) {
      toast.error(t('error.something_wrong'))
    } finally {
      setIsSubmitting(false)
    }
  }

  const footerContent = (
    <>
      <SimpleButton className="cancel-button" onClick={onClose} disabled={isSubmitting}>
        {t('cancel')}
      </SimpleButton>
      <SimpleButton className="submit-button" onClick={handleSubmit} disabled={isSubmitDisabled}>
        {t('submit')}
      </SimpleButton>
    </>
  )

  return (
    <PageModal toggle onToggle={onClose} title={t('spareparts.submit-feedback-title')} footerContent={footerContent} className="request-review-page-modal">
      <div className="request-modal-form">
        <div className="form-group">
          <label className="form-label">{t('part_number')}</label>
          <input type="text" className="form-input" value={sparePart.item_id} disabled />
        </div>
        <div className="form-group">
          <label className="form-label">{t('spareparts.part-name')}</label>
          <input type="text" className="form-input" value={sparePart.description} disabled />
        </div>
        <div className="form-group">
          <label className="form-label">
            {t('dealer-portal.comments')} <span className="required">*</span>
          </label>
          <textarea
            className="form-textarea"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            placeholder={t('spareparts.request-review-comments-placeholder')}
            rows={4}
          />
        </div>
      </div>
    </PageModal>
  )
}

export default RequestReviewModal
